(function () {
  const SESSION_KEY = 'notify_me_ajax_success';

  function decodeHtmlEntities(text) {
    if (!text || text.indexOf('&') === -1) {
      return text;
    }
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  function getNotifyStrings() {
    const notify = window.notify_me || {};
    return {
      success: decodeHtmlEntities(
        notify.success ||
          "Thanks! We've received your request and will respond shortly when this product/variant becomes available!"
      ),
      error: decodeHtmlEntities(
        notify.error || 'Please use a valid email address, such as john@example.com.'
      ),
    };
  }

  function stripContactPostedFromUrl() {
    if (window.location.href.indexOf('contact_posted=true') === -1) {
      return;
    }
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      url.searchParams.delete('form_type');
      const query = url.searchParams.toString();
      const next = url.pathname + (query ? '?' + query : '') + url.hash;
      window.history.replaceState(null, document.title, next);
    } catch (e) {
      window.history.replaceState(null, document.title, window.location.href.split('?')[0]);
    }
  }

  function consumeAjaxSuccessSession() {
    if (sessionStorage.getItem(SESSION_KEY) === '1') {
      sessionStorage.removeItem(SESSION_KEY);
      stripContactPostedFromUrl();
      return true;
    }
    return false;
  }

  function setNotifyFormMessage(form, type, message) {
    let messageEl = form.querySelector('[data-form-message="notifyMe"]');
    if (!messageEl) {
      messageEl = document.createElement('div');
      messageEl.className = 'form-message hidden';
      messageEl.setAttribute('data-form-message', 'notifyMe');
      messageEl.setAttribute('aria-live', 'polite');
      form.appendChild(messageEl);
    }

    messageEl.classList.remove('hidden');
    messageEl.replaceChildren();

    const box = document.createElement('div');
    box.className = type === 'success' ? 'alertBox alertBox--success' : 'alertBox alertBox--error';

    const paragraph = document.createElement('p');
    paragraph.className = 'alertBox-message';
    paragraph.textContent = message;

    box.appendChild(paragraph);
    messageEl.appendChild(box);

    const notifyText = form.parentElement && form.parentElement.querySelector('.notifyMe-text');
    if (notifyText) {
      notifyText.replaceChildren(box.cloneNode(true));
    }
  }

  function resetNotifyForm(form) {
    form.classList.remove('is-notify-submitted');
    const field = form.querySelector('.form-field');
    if (field) {
      field.classList.remove('hidden');
    }
    const messageEl = form.querySelector('[data-form-message="notifyMe"]');
    if (messageEl) {
      messageEl.classList.add('hidden');
      messageEl.replaceChildren();
    }
    const notifyText = form.parentElement && form.parentElement.querySelector('.notifyMe-text');
    if (notifyText) {
      notifyText.replaceChildren();
    }
    const submitButton = form.querySelector('[data-notify-me-submit]');
    if (submitButton) {
      submitButton.disabled = false;
    }
    const emailInput = form.querySelector('input[name="contact[email]"]');
    if (emailInput) {
      emailInput.value = '';
    }
  }

  function showNotifySuccess(form) {
    const strings = getNotifyStrings();
    form.classList.add('is-notify-submitted');
    sessionStorage.setItem(SESSION_KEY, '1');

    const field = form.querySelector('.form-field');
    if (field) {
      field.classList.add('hidden');
    }

    setNotifyFormMessage(form, 'success', strings.success);

    if (form.closest('[data-notify-popup]')) {
      document.body.classList.add('notify-me-show');
    }

    const submitButton = form.querySelector('[data-notify-me-submit]');
    if (submitButton) {
      submitButton.disabled = true;
    }

    const emailInput = form.querySelector('input[name="contact[email]"]');
    if (emailInput) {
      emailInput.value = '';
    }
  }

  function extractContactErrors(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const errorBox = doc.querySelector('.alertBox--error .alertBox-message, .errors li, .form-message .alertBox--error');
    if (!errorBox) {
      return null;
    }
    return (errorBox.textContent || '').trim();
  }

  function validateNotifyForm(form) {
    const emailInput = form.querySelector('input[name="contact[email]"]');
    if (!emailInput) {
      return false;
    }
    if (!emailInput.checkValidity()) {
      emailInput.reportValidity();
      return false;
    }
    return true;
  }

  function submitNotifyForm(form) {
    if (form.classList.contains('is-notify-submitted')) {
      return Promise.resolve();
    }
    if (!validateNotifyForm(form)) {
      return Promise.resolve();
    }

    const submitButton = form.querySelector('[data-notify-me-submit]');
    if (submitButton) {
      submitButton.disabled = true;
    }

    const action = form.getAttribute('action') || '/contact';

    return fetch(action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      redirect: 'manual',
      headers: {
        Accept: 'text/html,application/xhtml+xml',
      },
    })
      .then((response) => {
        const redirectedSuccess =
          response.type === 'opaqueredirect' ||
          (response.status >= 300 && response.status < 400) ||
          (response.url && response.url.indexOf('contact_posted=true') > -1);

        if (redirectedSuccess || response.status === 0) {
          showNotifySuccess(form);
          return;
        }

        return response.text().then((html) => {
          if (html.indexOf('contact_posted=true') > -1) {
            showNotifySuccess(form);
            return;
          }
          const errorText = extractContactErrors(html);
          if (errorText) {
            setNotifyFormMessage(form, 'error', errorText);
            if (submitButton) {
              submitButton.disabled = false;
            }
            return;
          }
          showNotifySuccess(form);
        });
      })
      .catch(() => {
        setNotifyFormMessage(form, 'error', getNotifyStrings().error);
        if (submitButton) {
          submitButton.disabled = false;
        }
      });
  }

  function handleNotifySubmit(event) {
    const trigger = event.target.closest('[data-notify-me-submit]');
    if (!trigger) {
      return;
    }
    const form = trigger.closest('.notifyMe-form');
    if (!form) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    submitNotifyForm(form);
  }

  document.addEventListener('click', handleNotifySubmit, true);

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter') {
        return;
      }
      const input = event.target;
      if (!input.matches || !input.matches('.notifyMe-form input[name="contact[email]"]')) {
        return;
      }
      const form = input.closest('.notifyMe-form');
      if (!form) {
        return;
      }
      event.preventDefault();
      submitNotifyForm(form);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('.notifyMe-form');
      if (!form) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      submitNotifyForm(form);
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-close-notify-popup]')) {
      return;
    }
    document.querySelectorAll('.notifyMe-form.is-notify-submitted').forEach((form) => {
      resetNotifyForm(form);
    });
  });

  window.notifyMeForm = {
    consumeAjaxSuccessSession,
    stripContactPostedFromUrl,
  };
})();
